var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "createAccount", attrs: { id: "create-account-app" } },
    [
      _c(
        "div",
        { staticClass: "accountContainer" },
        [
          _c("progress-tracker", { attrs: { steps: _vm.steps } }),
          _vm._v(" "),
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: _vm.darkMode
                ? _vm.brandingService.getLoginDarkLogoUrl()
                : _vm.brandingService.getLoginLogoUrl(),
              alt: "brandingService.getLoginLogoAlt()",
            },
          }),
          _vm._v(" "),
          !_vm.submitted
            ? _c(
                "section",
                { staticClass: "middle form" },
                [
                  _c("h1", [_vm._v("Create An Account")]),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.allFieldsValid,
                        callback: function ($$v) {
                          _vm.allFieldsValid = $$v
                        },
                        expression: "allFieldsValid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "name",
                        attrs: {
                          rules: [_vm.rules.required],
                          solo: "",
                          flat: "",
                          outlined: "",
                          dense: "",
                          label: "Name",
                        },
                        model: {
                          value: _vm.userName,
                          callback: function ($$v) {
                            _vm.userName = $$v
                          },
                          expression: "userName",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "email",
                        attrs: {
                          rules: [_vm.rules.required, _vm.rules.formatEmail],
                          solo: "",
                          flat: "",
                          outlined: "",
                          dense: "",
                          label: "Business Email",
                        },
                        model: {
                          value: _vm.userEmail,
                          callback: function ($$v) {
                            _vm.userEmail = $$v
                          },
                          expression: "userEmail",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "subInstruction" }, [
                        _vm._v(
                          "Your email must be a business email address (personal emails not accepted)."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "termsOutline" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("h4", [
                            _vm._v(
                              "Acknowlege Terms (required to use the service)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "documents" }, [
                            _vm._v(
                              "\n              By continuing, you aknowledge that you have read and understand HP's \n              "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Privacy Statement")]
                            ),
                            _vm._v(",\n              "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                                  target: "_blank",
                                },
                              },
                              [_vm._v("EULA")]
                            ),
                            _vm._v(",\n              and "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                                  target: "_blank",
                                },
                              },
                              [_vm._v("DPA")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "legend-title legend-switch action-switch",
                              attrs: { align: "left" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.termsAccepted,
                                    expression: "termsAccepted",
                                  },
                                ],
                                attrs: {
                                  id: "enabled",
                                  type: "checkbox",
                                  "aria-checked": _vm.termsAccepted.toString(),
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.termsAccepted)
                                    ? _vm._i(_vm.termsAccepted, null) > -1
                                    : _vm.termsAccepted,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.termsAccepted,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.termsAccepted = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.termsAccepted = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.termsAccepted = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "legend-slider" }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "consent" },
                        [
                          _c("v-checkbox", {
                            staticClass: "consentCheck",
                            attrs: {
                              label:
                                "I consent to receive communications from HP. I understand I may opt out of promotional and product information emails at any time.",
                            },
                            model: {
                              value: _vm.communicationConsent,
                              callback: function ($$v) {
                                _vm.communicationConsent = $$v
                              },
                              expression: "communicationConsent",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary submit",
                          attrs: {
                            onsubmit: "false",
                            disabled: !_vm.allFieldsValid || !_vm.termsAccepted,
                          },
                          on: { click: _vm.submitEmail },
                        },
                        [_vm._v("Submit")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.submitted
            ? _c("section", { staticClass: "middle submitted" }, [
                !_vm.error
                  ? _c("div", [
                      _c("h1", [_vm._v("Check Your Email")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "Before you get started, we need to verify your email address. WXP Collaboration will send an email within 2-3 hours."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "pli",
                        attrs: { src: "dist/images/PLI-image.png" },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.error
                  ? _c("div", [
                      _c("h1", [_vm._v("Something Went Wrong")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.error) + "\n        "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "copywrite" }, [
            _vm._v("© " + _vm._s(_vm.currentYear) + " HP Inc. "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                  target: "_blank",
                },
              },
              [_vm._v("Privacy Statement")]
            ),
            _vm._v(",\n      "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                  target: "_blank",
                },
              },
              [_vm._v("EULA")]
            ),
            _vm._v(",\n      and "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                  target: "_blank",
                },
              },
              [_vm._v("DPA")]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }